import styled from 'styled-components';

import {
  xdlColorControlFillTertiary,
  xdlColorError,
  xdlColorCaution,
  xdlColorSuccess,
  xdlColorHighlighted,
  xdlColorTextSecondaryOnLight,
  spaceS,
  scale060,
} from '@xing-com/tokens';

export const colors: { [key: number]: string } = {
  0: xdlColorControlFillTertiary,
  1: xdlColorError,
  2: xdlColorCaution,
  3: xdlColorSuccess,
  4: xdlColorHighlighted,
};

export const strengthToColor = (strength: number): string => {
  const range: number[] = Object.keys(colors).map(Number);
  const min = Math.min(...range);
  const max = Math.max(...range);

  if (strength < min) return colors[min];
  if (strength > max) return colors[max];

  return colors[strength];
};

export const strengthToWidth = (strength: number): string =>
  20 * strength + '%';

const PasswordStrengthIndicator = styled.div<{ strength: number }>`
  margin-top: ${spaceS};
  height: 6px;
  position: relative;
  overflow: hidden;
  background-color: ${colors[0]};

  &:before {
    bottom: 0px;
    content: '';
    left: 0px;
    position: absolute;
    top: 0px;
    transition: all 0.5s ease-out 0s;
    background: ${({ strength }) => strengthToColor(strength)};
    width: ${({ strength }) => strengthToWidth(strength)};
  }
`;

const PasswordStrengthIndicatorText = styled.div<{ error: boolean }>`
  text-align: center;
  margin-top: ${spaceS};
  font-size: ${scale060};
  font-style: italic;
  font-weight: light;
  color: ${({ error }) =>
    error ? xdlColorError : xdlColorTextSecondaryOnLight};
`;

export { PasswordStrengthIndicatorText, PasswordStrengthIndicator };
